<template>
    <div class="ap">
        <scaleArea id="scale" :scales="scales" :selectedNode="selectedNode" ref="scale" @showAllUsers="showAllUsers" @hideAllUsers="hideAllUsers">
        </scaleArea>
        <div id="map" :class="{ 'map' : scales.showTimeScale, 'map-full' : !scales.showTimeScale}">
        </div>
        <div class="menu" id="markerMenu">
            <table width="100%">
                <tr class="menu-record"><button class="transparent-button" type="button" v-on:click="handleChangeIcon()"><td class="menu-item" v-t="'message.menu_map_icon_change'"></td></button></tr>
                <tr class="menu-record"><button class="transparent-button" type="button" v-on:click="handleHideIcon()"><td class="menu-item" v-t="'message.menu_map_icon_hide'"></td></button></tr>
            </table>
        </div>
    </div>
</template>

<script>
import scaleArea from './ScaleArea'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

const CLOSE_BOX_URL = 'https://aldio-public.s3.ap-northeast-1.amazonaws.com/web_icon/icon_close.svg';

function CustomMarker(mapComponent, map, showUpdateOnly, locData) {
    this.mapComponent = mapComponent;
    this.showUpdateOnly = showUpdateOnly;
    this.locData = locData;
    this.markerElementList = [];
    this.map = map;
    this.setMap(map);
}

export default {
    components: {
        'scaleArea': scaleArea,
    },
    props: {
        appData: Object,
        selectedNode: Object,
    },
    data() {
        return {
            tabletBrowser: false,
            markerTapTime: null,
            markerIconList: null,
            mapName: "map",
            map: null,
            trafficLayer: null,
            myLatLng: {
                lat: 35.681167,
                lng: 139.767052
            },
            selectedMarker: null,
            markerContextMenu: false,
            time: null,
            lines: [],
            lineMarkers: [],
            scales: {
                range: {
                    min: -10080,
                    max: 0
                },
                disable: true,
                timeRange: {
                    minTime: new Date(),
                    maxTime: new Date()
                },
                changeFlg: false,
                autoUpdateLocationFlg: false,
                showTimeScale: true,
                showTraffic: false,
                updateInterval: 30,
                resetMaxTimeFlg: false,
                now: new Date(),
                trackingLastUpdate: 0,
            },
            acquireTimeRange: {
                minTime: new Date(),
                maxTime: new Date()
            },
            locData: new Map(),
            currentTimeRange: {
                minTime: new Date(),
                maxTime: new Date()
            },
            nameData: new Map(),
            timer: null,
            current_zoom: 8,
            lastGetLocationTime: null,
            maxLocInfo : {
                lat: null,
                lng: null
            },
            minLocInfo : {
                lat: null,
                lng: null
            },
            markerLayer: null,
            userLocCountInDisplayRange: 0,
            latestUserInfo: {
                lat: null,
                lng: null,
                time: null
            },
            changeZoomToAll: false,
            userPanToCenter: false,
            timerObj: null,
            lineMarkerInfoBoxOpened: false,
            infoBoxOfLineMarker: null,
        }
    },
    methods: {
        initMap() {
            if (this.timerObj != null) {
                clearInterval(this.timerObj);
            }
            var this_2 = this;
            this.map = new google.maps.Map(document.getElementById(this.mapName), {
                center: this.myLatLng,
                zoom: this.current_zoom,
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: false,
                styles: [
                  {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.neighborhood",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.business",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "labels.text",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  }
                ]
            });
            this.trafficLayer = new google.maps.TrafficLayer();
        },
        getLocationData: function(autoUpdate) {
            if (this.map == null) {
                return;
            }
            this.clearData();
            this.clearLine();
            if (!autoUpdate) {
                // clear marker after getting location data when autoUpdate is true.
                // because marker will be removed during getting the location data.
                this.clearMarker();
            }
            let endpoint;
            let input = {};
            if (this.isTalkgroup) {
                endpoint = '/getlocationdata';
                input.talkgroupId = this.selectedNode.data.id;
            } else {
                input.userId = this.selectedNode.data.id;
                if (autoUpdate) {
                    if (this.lastGetLocationTime == null) {
                        let tmpTime = new Date()
                        tmpTime.setSeconds(tmpTime.getSeconds() - this.scales.updateInterval);
                        input.startTime = tmpTime.toISOString();
                    } else {
                        input.startTime = this.lastGetLocationTime.toISOString();
                    }
                    this.lastGetLocationTime = new Date();
                    input.endTime = this.lastGetLocationTime.toISOString();
                    input.needLastLocation = true;
                } else {
                    input.startTime = this.scales.timeRange.minTime.toISOString();
                    input.endTime = this.scales.timeRange.maxTime.toISOString();
                }
                endpoint = '/getpersonallocationdata';
            }
            let self = this;
            server.post(endpoint, input)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (this.isUser) {
                                self.userLocCountInDisplayRange = res.data.locations.length;
                            }
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            let value = self.locData.get(this.selectedNode.data.id);
                            if (value == null || value.length == 0) {
                                if (this.isTalkgroup) {
                                    commonUtil.notifyMessage(self, "Warning",commonUtil.getMessageText(self.$i18n,"error_location_not_found"));
                                } else {
                                    if (!autoUpdate) {
                                        let message = commonUtil.getMessageText(self.$i18n,"error_location_not_found_with_time");
                                        message = message.replace('{startTime}', new Date(input.startTime).toLocaleString());
                                        message = message.replace('{endTime}', new Date(input.endTime).toLocaleString());
                                        commonUtil.notifyMessage(self, "Warning",message);
                                    }
                                }
                                self.clearMarker();
                            }
                            return;
                        case constants.STATUS_ERROR_USER_NOT_FOUND:
                            return;
                        default:
                            commonUtil.notifyMessage(self, "Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getLocationData").replace("{code}",res.data.status));
                            return;
                    }
                    if (self.isTalkgroup) {
                        self.mergeNameData(res.data.locations, null, null);
                    } else {
                        self.mergeNameData(res.data.locations, new Date(input.startTime), new Date(input.endTime));
                    }
                    self.mergeLocData(res.data.locations);
                    if (autoUpdate) {
                        self.clearMarker();
                    }
                    self.drawLocation();
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self, "getLocationData", error);
                });
        },
        mergeNameData: function(nameData, startTime, endTime) {
            var this_2 = this;
            for (var i = 0; i < nameData.length; i++) {
                var value = this_2.nameData.get(nameData[i].userId);
                if (value == null) {
                    this_2.nameData.set(nameData[i].userId, {
                        name: nameData[i].name,
                        userId: nameData[i].userId,
                        displayName: nameData[i].displayName,
                        marker: nameData[i].markerIcon,
                        hide: false,
                        infoWindow: null,
                        infoWindowOpened: false,
                        startTime: startTime,
                        endTime: endTime
                    });
                } else {
                    value.startTime = startTime;
                    value.endTime = endTime;
                }
            }
        },
        mergeLocData: function(locationData) {
            var lastUpdateTime = new Date()
            lastUpdateTime.setSeconds(lastUpdateTime.getSeconds() - this.scales.trackingLastUpdate);
            this.maxLocInfo.lat = -90;
            this.maxLocInfo.lng = -180;
            this.minLocInfo.lat = 90;
            this.minLocInfo.lng = 180;
            for (var i = 0; i < locationData.length; i++) {
                let userData = this.nameData.get(locationData[i].userId);
                let updateFlag = false;
                if (new Date(locationData[i].time).getTime() - lastUpdateTime.getTime() >= 0) {
                    updateFlag = true;
                }
                if (((this.showUpdateOnly) && (updateFlag)) || (!userData.hide)) {
                    this.setMinMaxLocInfo(locationData[i].lat, locationData[i].lng);
                }
                var location = {
                    time: new Date(locationData[i].time),
                    lat: locationData[i].lat,
                    lng: locationData[i].lng,
                    update: updateFlag,
                    inShowRange: true,
                };
                var userLocationDataList = this.locData.get(locationData[i].userId);
                if ((userLocationDataList == null) || (userLocationDataList.length == 0)) {
                    this.locData.set(locationData[i].userId, [location]);
                } else {
                    if (userLocationDataList[0].time.getTime() != location.time.getTime()) {
                        userLocationDataList.push(location);
                        if ((this.isUser) && (this.scales.autoUpdateLocationFlg)) {
                            //
                            // delete the data which time is one day older than the latest data when auto updating of user's location data.
                            //
                            let minLocationDate = new Date(userLocationDataList[0].time);
                            minLocationDate.setDate(minLocationDate.getDate() - 1);
                            for (let i = 0 ; i < userLocationDataList.length ; i++) {
                                if (new Date(userLocationDataList[i].time).getTime() < minLocationDate.getTime()) {
                                    userLocationDataList.splice(i, 1);
                                    continue;
                                }
                            }
                        }
                    } else {
                        // new location data is same as latest location data.
                    }
                }
            };
            var values = this.locData.values();
            if (values.length <= 1) {
                return;
            }
            for (var value of values) {
                value.sort(function(a, b) {
                    if (a.time > b.time) return -1;
                    if (a.time < b.time) return 1;
                    return 0;
                });
            }
            if (this.isUser) {
                let selectedUserLoc = this.locData.get(this.selectedNode.data.id);
                this.latestUserInfo.lat = selectedUserLoc[0].lat;
                this.latestUserInfo.lng = selectedUserLoc[0].lng;
                this.latestUserInfo.time = selectedUserLoc[0].time;
            }
        },
        drawInitialLine: function() {
            let userData = this.nameData.get(this.selectedNode.data.id);
            if (userData.hide) {
                return false;
            }
            this.locData.forEach((value, key) => {
                for (var loc = 0; loc < value.length - 1; loc++) {
                    if ((value[loc].inShowRange) && (value[loc + 1].inShowRange)) {
                        this.drawLine(value[loc], value[loc + 1], userData);
                        this.setMinMaxLocInfo(value[loc].lat, value[loc].lng);
                        this.setMinMaxLocInfo(value[loc + 1].lat, value[loc + 1].lng);
                    }
                }
            });
            return true;
        },
        createMarker: function() {
            let locale = "ja-Jp";
            let this_2 = this;

            // inherit google.maps.OverlayView
            CustomMarker.prototype = new google.maps.OverlayView();

            if (this.changeZoomToAll) {
                if (this.isTalkgroup) {
                    if (this.existShowMarker()) {
                        // show latest user location in group.
                        if (this.locData.size == 1) {
                            let latLng = new google.maps.LatLng(this_2.minLocInfo.lat, this_2.minLocInfo.lng);
                            this_2.map.setCenter(latLng);
                        } else {
                            let latLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(this_2.minLocInfo.lat, this_2.minLocInfo.lng), new google.maps.LatLng(this_2.maxLocInfo.lat, this_2.maxLocInfo.lng));
                            this_2.map.fitBounds(latLngBounds);
                        }
                    }
                } else {
                    // show tracking location data of specific user.
                    switch(this.userLocCountInDisplayRange) {
                        case 0:
                            // no user data in display range.
                            return;
                        case 1:
                            // only one user data in display range.
                            if (this.existShowMarker()) {
                                let latLng = new google.maps.LatLng(this_2.minLocInfo.lat, this_2.minLocInfo.lng);
                                this_2.map.setCenter(latLng);
                            }
                            break;
                        default:
                            if (this.existShowMarker()) {
                                let latLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(this_2.minLocInfo.lat, this_2.minLocInfo.lng), new google.maps.LatLng(this_2.maxLocInfo.lat, this_2.maxLocInfo.lng));
                                this_2.map.fitBounds(latLngBounds);
                            }
                            break;
                    }
                }
                if (this_2.markersInNarrowFiled()) {
                    this_2.map.setZoom(16);
                }
            } else {
                if (this_2.userPanToCenter) {
                    this_2.map.panTo(new google.maps.LatLng(this_2.minLocInfo.lat, this_2.minLocInfo.lng));
                    this_2.userPanToCenter = false;
                }
            }
            this.changeZoomToAll = false;

            this_2.markerLayer = new CustomMarker( this_2, this_2.map, false, this.locData);
            this_2.map.addListener("click", function(e) {
                this_2.closeMarkerContextMenu();
            });
            CustomMarker.prototype.onAdd = function() {
                if (this.markerElementList.length == 0) {
                    var panes = this.getPanes();
                    this.locData.forEach((value, key) => {
                        if (value.length == 0) {
                            return;
                        }
                        let userData = this_2.nameData.get(key);

                        if (!this_2.isTalkgroup && !(this_2.isUser && (this_2.selectedNode.data.id == key))) {
                            return;
                        }

                        // get marker icon position from lat/lng
                        let timeForInfoWindow
                        if (this_2.isTalkgroup) {
                            timeForInfoWindow = value[0].time;
                        } else {
                            timeForInfoWindow = this_2.latestUserInfo.time;
                        }

                        let markerElement = document.createElement('div');
                        markerElement.id = key

                        markerElement.classList.add('marker' + ((value[0].update) ? '' : '--not-updated'));

                        var icon_img = document.createElement("img");
                        icon_img.classList.add('marker-img');
                        if ((userData.marker == null) || (userData.marker == "")) {
                            icon_img.src = constants.ICON_IMAGE_PATH + "default_marker.png";
                        } else {
                            icon_img.src = userData.marker;
                        }

                        let markerInfo = document.createElement('div');
                        markerInfo.id = key + "-info"
                        markerInfo.classList.add('marker-info');
                        markerInfo.innerHTML = userData.displayName;

                        markerElement.appendChild(icon_img);
                        markerElement.appendChild(markerInfo);

                        if (((this.showUpdateOnly) && (!value[0].updated)) || (userData.hide)) {
                            markerElement.style.display = 'none';
                        }

                        // set top/left position
                        markerElement.style.position = "absolute";
                        // adjust the position of marker icon. move 24px(half size of icon) to upper left
                        panes.overlayLayer.appendChild(markerElement);

                        if ((this_2.isUser) && (!this_2.scales.autoUpdateLocationFlg) && (!userData.hide)) {
                            userData.infoWindow = null;
                            let point = this.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(this_2.latestUserInfo.lat, this_2.latestUserInfo.lng));
                            let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 30, point.y - 24), this.map.getZoom(), true);
                            // set infoBox content (use infobox.js : v3 library)
                            let infoBoxContent = commonUtil.getMessageText(this_2.$i18n, "info_map_marker")
                                .replace("{userName}", userData.displayName)
                                .replace("{time}", timeForInfoWindow.toLocaleString(locale))
                                .replace(/{latitude}/g, this_2.latestUserInfo.lat)
                                .replace(/{longitude}/g, this_2.latestUserInfo.lng);
                            // create infoBox
                            let infoBoxOptions = {
                                content: infoBoxContent,
                                alignBottom: true,
                                position: latLng,
                                pixelOffset: new google.maps.Size(-30, 0),
                                boxClass: "info-box",
                                closeBoxMargin: "8px 0px 0px 0px",
                                closeBoxURL: CLOSE_BOX_URL,
                            };
                            this_2.infoBoxOfLineMarker = new InfoBox(infoBoxOptions);
                            this_2.infoBoxOfLineMarker.open(this_2.map);
                            this_2.lineMarkerInfoBoxOpened = true;
                            google.maps.event.addDomListener(markerElement, 'click', function(events, markerElement) {
                                this_2.infoBoxOfLineMarker.setContent(infoBoxContent);
                                this_2.infoBoxOfLineMarker.setPosition(latLng);
                                this_2.infoBoxOfLineMarker.open(this_2.map);
                                this_2.lineMarkerInfoBoxOpened = true;
                            });
                            google.maps.event.addListener(this_2.infoBoxOfLineMarker, 'closeclick', function(event) {
                                this_2.lineMarkerInfoBoxOpened = false;
                            });
                        } else {
                            let point = this.getProjection().fromLatLngToDivPixel( new google.maps.LatLng( value[0].lat, value[0].lng ) );
                            let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 0, point.y - 0), this.map.getZoom(), true);
                            let infoBoxContent = commonUtil.getMessageText(this_2.$i18n,"info_map_marker")
                                .replace("{userName}", userData.displayName)
                                .replace("{time}", timeForInfoWindow.toLocaleString(locale))
                                .replace(/{latitude}/g, value[0].lat)
                                .replace(/{longitude}/g, value[0].lng);

                            if (userData.infoWindow == null) {
                                // set infoBox content (use infobox.js : v3 library)
                                // create infoBox
                                let infoBoxOptions = {
                                    content: infoBoxContent,
                                    alignBottom: true,
                                    position: latLng,
                                    pixelOffset: new google.maps.Size(-30, 0),
                                    boxClass: "info-box",
                                    closeBoxMargin: "8px 0px 0px 0px",
                                    closeBoxURL: CLOSE_BOX_URL,
                                    disableAutoPan: true,
                                };
                                userData.infoWindow = new InfoBox(infoBoxOptions);
                                userData.infoWindowOpened = false;
                            } else {
                                userData.infoWindow.setContent(infoBoxContent);
                                userData.infoWindow.setPosition(latLng);
                            }
                            google.maps.event.addDomListener(markerElement, 'click', function(events, markerElement) {
                                userData.infoWindow.open(self.map, markerElement);
                                userData.infoWindowOpened = true;
                            });
                            userData.infoWindow.addListener( "closeclick", function ( argument ) {
                                userData.infoWindowOpened = false;
                            });
                        }

                        let self = this;
                        panes.overlayMouseTarget.appendChild(markerElement);
                        google.maps.event.addDomListener(markerElement, 'contextmenu', function(events) {
                            self.mapComponent.showMarkerDialog(userData, event);
                        });
                        this.markerElementList.push(markerElement);
                    });
                }
            }
            // draw marker layer. It will be called on drawing or moving or zooming
            CustomMarker.prototype.draw = function() {
                var panes = this.getPanes();
                this.locData.forEach((value, key) => {
                    if (value.length == 0) {
                        return;
                    }
                    let userData = this_2.nameData.get(key);
                    // get marker icon position from lat/lng
                    let point;
                    let showMarker = false;
                    if (this_2.isUser) {
                        if (userData.userId == this_2.selectedNode.data.id) {
                            if (userData.infoWindow != null) {
                            	userData.infoWindow.setContent(commonUtil.getMessageText(this_2.$i18n,"info_map_marker")
                            	    .replace("{userName}",userData.displayName)
                            	    .replace("{time}",this_2.latestUserInfo.time.toLocaleString(locale))
                            	    .replace(/{latitude}/g, value[0].lat)
                            	    .replace(/{longitude}/g, value[0].lng));
                            }
                            point = this.getProjection().fromLatLngToDivPixel( new google.maps.LatLng( this_2.latestUserInfo.lat, this_2.latestUserInfo.lng ) );
                            showMarker = true;
                        }
                    } else {
                        point = this.getProjection().fromLatLngToDivPixel( new google.maps.LatLng( value[0].lat, value[0].lng ) );
                        showMarker = true;
                    }
                    if (showMarker) {
                        if (userData.infoWindowOpened) {
                            // adjust the position of infoWindow when it has opened.
                            let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 80, point.y - 24), this.map.getZoom(), true);
                            userData.infoWindow.setPosition(latLng);
                        }
                        let markerElement = document.getElementById(key);
                        if (markerElement != null) {
                            // adjust the position of marker icon. move 24px(half size of icon) to upper left
                            markerElement.style.left = (point.x - 24) + 'px';
                            markerElement.style.top = (point.y - 24 ) + 'px';
                        }
                    }
                    if (this_2.lineMarkerInfoBoxOpened) {
                        point = this.getProjection().fromLatLngToDivPixel( new google.maps.LatLng(this_2.latestUserInfo.lat, this_2.latestUserInfo.lng) );
                        let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 80, point.y - 24), this.map.getZoom(), true);
                        this_2.infoBoxOfLineMarker.setPosition(latLng);
                    }
                });
            }
            // remove marker from layer
            CustomMarker.prototype.remove = function() {
                if (this.markerElementList.length > 0) {
                    for (let markerElement of this.markerElementList) {
                        markerElement.parentNode.removeChild(markerElement);
                    }
                    this.markerElementList = [];
                }
            }
            CustomMarker.prototype.clearLayer = function() {
                this.setMap(null);
            }
        },
        showAllUsers: function() {
            if (this.markerLayer == null) {
                return;
            }
            for (let markerElement of this.markerLayer.markerElementList) {
                // cause click event
                markerElement.click();
            }
        },
        hideAllUsers: function() {
            if (this.markerLayer == null) {
                return;
            }
            for (let markerElement of this.markerLayer.markerElementList) {
                let numberId = Number(markerElement.id);
                let userData = this.nameData.get(numberId);
                if ((userData == null) || (userData.infoWindow == null) || !userData.infoWindowOpened) {
                    continue;
                }
                userData.infoWindow.close();
                userData.infoWindowOpened = false;
            }
        },
        drawLine: function(location1, location2, userData) {
            let fromLocation = new google.maps.LatLng(location1.lat, location1.lng);
            let toLocation = new google.maps.LatLng(location2.lat, location2.lng);
            let locale = "ja-Jp";

            var lineSymbol = {
                path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                scale: 3,
            };
            var line = new google.maps.Polyline({
                path: [{
                    lat: location1.lat,
                    lng: location1.lng
                }, {
                    lat: location2.lat,
                    lng: location2.lng
                }],
                strokeColor: 'rgba(61, 125, 211, 1)',
                strokeWeight: 3,
                icons: [{
                    icon: {
                        path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                        scale: 3,
                    },
                    offset: '0',
                }],
                map: this.map,
            });
            // color of marker on line sets to transparent
            // position of marker is same as arrow-icon on line
            // markers use to show infoBox(update time) by click
            var lineMarkerSymbol = {
                path: google.maps.SymbolPath.CIRCLE,
                strokeColor: 'rgba(0, 0, 0, 0)',
                scale: 4,
            }
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(location2.lat ,location2.lng),
                map: this.map,
                icon: lineMarkerSymbol
            });

            let infoBoxContent = commonUtil.getMessageText(this.$i18n,"info_map_marker")
                .replace("{userName}", userData.displayName)
                .replace("{time}", location2.time.toLocaleString(locale))
                .replace(/{latitude}/g, location2.lat)
                .replace(/{longitude}/g, location2.lng);

            let self = this;
            marker.addListener( "click", function ( event ) {
                // infoBox of marker on line will move (and change content) when other marker has clicked.
                self.infoBoxOfLineMarker.setContent(infoBoxContent);
                self.infoBoxOfLineMarker.setPosition(marker.getPosition());
                if (!self.lineMarkerInfoBoxOpened) {
                    self.lineMarkerInfoBoxOpened = true;
                    self.infoBoxOfLineMarker.open(self.map, marker);
                }
            } ) ;
            // lines and linkMarkers will be saved for clearing process
            this.lines.push(line);
            this.lineMarkers.push(marker);
        },
        closeMarkerContextMenu() {
            if (this.markerContextMenu) {
                let markerMenu = document.getElementById("markerMenu");
                markerMenu.style.display = "none";
                this.markerContextMenu = false;
            }
        },
        clearMarker: function() {
            if (this.markerLayer != null) {
                this.markerLayer.clearLayer();
            }
        },
        closeInfoWindowOfUser(userId) {
            let userData = this.nameData.get(userId);
            if (userData != null) {
                if (userData.infoWindowOpened) {
                    userData.infoWindow.close();
                    userData.infoWindowOpened = false;
                }
            }
        },
        clearLine: function() {
            for (var i = 0; i < this.lines.length; i++) {
                this.lines[i].setMap(null);
            }
            this.lines = [];
            for (var i = 0; i < this.lineMarkers.length; i++) {
                this.lineMarkers[i].setMap(null);
            }
            this.lineMarkers = [];
            if (this.lineMarkerInfoBoxOpened) {
                this.infoBoxOfLineMarker.close();
                this.lineMarkerInfoBoxOpened = false;
            }
            this.infoBoxOfLineMarker = null;
        },
        drawLocation: function() {
            if (this.isUser) {
                if (!this.drawInitialLine()) {
                    return;
                }
            }
            this.createMarker();
        },
        trimTime: function(date_1, date_2) {
            this.locData.forEach((value, key) => {
                for (var loc = value.length - 1; loc >= 0; loc--) {
                    if (date_1 < value[loc].time && value[loc].time < date_2) {
                        value[loc].inShowRange = false;
                    }
                }
            });
        },
        personalDataModify: function() {
            this.userLocCountInDisplayRange = 0;
            let self = this;
            this.locData.forEach((value, key) => {
                for (var loc = value.length - 1; loc >= 0; loc--) {
                    if (self.scales.timeRange.minTime < value[loc].time && value[loc].time < self.scales.timeRange.maxTime) {
                        value[loc].inShowRange = true;
                        self.latestUserInfo.lat = value[loc].lat;
                        self.latestUserInfo.lng = value[loc].lng;
                        self.latestUserInfo.time = value[loc].time;
                        self.userLocCountInDisplayRange ++;
                    } else {
                        value[loc].inShowRange = false;
                    }
                }
            });
            this.currentTimeRange.maxTime = new Date(this.scales.timeRange.maxTime);
            this.currentTimeRange.minTime = new Date(this.scales.timeRange.minTime);
        },
        setScalesRange: function() {
            this.acquireTimeRange.maxTime = new Date(this.scales.now);
            this.acquireTimeRange.minTime = new Date(this.scales.now);
            this.currentTimeRange.maxTime = new Date(this.scales.now);
            this.currentTimeRange.minTime = new Date(this.scales.now);
            let minute = this.scales.now.getMinutes();
            this.acquireTimeRange.maxTime.setMinutes(minute + this.scales.range.max);
            this.acquireTimeRange.minTime.setMinutes(minute + this.scales.range.min);
            this.currentTimeRange.maxTime.setMinutes(minute + this.scales.range.max);
            this.currentTimeRange.minTime.setMinutes(minute + this.scales.range.min);
        },
        clearData: function() {
            this.maxLocInfo.lat = -90;
            this.maxLocInfo.lng = -180;
            this.minLocInfo.lat = 90;
            this.minLocInfo.lng = 180;
            this.locData = new Map();
        },
        changeActiveTalker: function() {
            this.latestUserLocation = null;
            this.scales.disable = false;
            this.scales.autoUpdateLocationFlg = true;
            if (this.isTalkgroup) {
                this.changeZoomToAll = true;
            } else {
                this.userPanToCenter = true;
            }

            this.acquireTimeRange.maxTime = this.currentTimeRange.maxTime;
            this.acquireTimeRange.minTime = this.currentTimeRange.minTime;

            this.getLocationData(this.scales.autoUpdateLocationFlg);
            if (this.scales.autoUpdateLocationFlg) {
                this.setTimer();
            }
        },
        setTimer: function() {
            this.scales.disable = true;
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(this.updateLocationByTimer, this.scales.updateInterval * 1000);
        },
        changeRange: function() {
            this.scales.changeFlg = false;
            let savedMaxLocInfo = this.maxLocInfo;
            let savedMinLocInfo = this.minLocInfo;
            this.latestUserInfo = {};
            this.maxLocInfo.lat = -90;
            this.maxLocInfo.lng = -180;
            this.minLocInfo.lat = 90;
            this.minLocInfo.lng = 180;
            let userData = this.nameData.get(this.selectedNode.data.id);
            if (userData.startTime == null ||
                userData.endTime == null ||
                userData.startTime.getTime() > new Date(this.scales.timeRange.minTime).getTime() ||
                userData.endTime.getTime() < new Date(this.scales.timeRange.maxTime).getTime()) {
                // required data has not get.
                this.getLocationData(false);
            } else {
                this.clearLine();
                this.clearMarker();
                // required data has already get. (change show range)
                this.personalDataModify();
                switch(this.userLocCountInDisplayRange) {
                    case 0:
                        this.maxLocInfo = savedMaxLocInfo;
                        this.minLocInfo = savedMinLocInfo;
                        this.$notify({title: 'Warning', message: commonUtil.getMessageText(this.$i18n,"error_location_not_found"), type: 'warning'});
                        return;
                    case 1:
                        this.maxLocInfo.lat = this.minLocInfo.lat = this.latestUserInfo.lat;
                        this.maxLocInfo.lng = this.minLocInfo.lng = this.latestUserInfo.lng;
                        break;
                    default:
                        break;
                }
                this.drawLocation();
            }
        },
        updateLocation: function() {
            this.scales.now = new Date();
            this.getLocationData(this.scales.autoUpdateLocationFlg);
        },
        updateLocationByTimer() {
            this.scales.now = new Date();
            this.getLocationData(this.scales.autoUpdateLocationFlg);
        },
        setMinMaxLocInfo(lat, lng) {
            if (this.maxLocInfo.lat == -90) {
                this.maxLocInfo.lat = lat;
            } else {
                this.maxLocInfo.lat = Math.max(this.maxLocInfo.lat, lat);
            }
            if (this.maxLocInfo.lng == -180) {
                this.maxLocInfo.lng = lng;
            } else {
                this.maxLocInfo.lng = Math.max(this.maxLocInfo.lng, lng);
            }
            if (this.minLocInfo.lat == 90) {
                this.minLocInfo.lat = lat;
            } else {
                this.minLocInfo.lat = Math.min(this.minLocInfo.lat, lat);
            }
            if (this.minLocInfo.lng == 180) {
                this.minLocInfo.lng = lng;
            } else {
                this.minLocInfo.lng = Math.min(this.minLocInfo.lng, lng);
            }
        },
        markersInNarrowFiled() {
            // check the distance between 2 locations
            let lat1 = this.minLocInfo.lat * Math.PI / 180;
            let lng1 = this.minLocInfo.lng * Math.PI / 180;
            let lat2 = this.maxLocInfo.lat * Math.PI / 180;
            let lng2 = this.maxLocInfo.lng * Math.PI / 180;
            let distance = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
            if (distance < 1) {
                // 2 locations are close when distance is smaller than 1km (zoom up the map)
                return true;
            } else {
                return false;
            }
        },
        handleChangeIcon() {
            this.closeMarkerContextMenu();
            if ((this.selectedMarker.marker == null) || ((this.selectedMarker.marker == ""))) {
                this.$emit('showMarkerIconList',this.selectedMarker.displayName, null);
            } else {
                this.$emit('showMarkerIconList',this.selectedMarker.displayName, this.selectedMarker.marker);
            }
        },
        handleHideIcon() {
            this.closeMarkerContextMenu();
            let userData = this.nameData.get(this.selectedMarker.userId);
            userData.hide = true;
            userData.infoWindow.close();
            userData.infoWindowOpened = false;
            let markerElement = document.getElementById(this.selectedMarker.userId);
            markerElement.style.display = "none";
            this.updateLocation();
            commonUtil.notifyMessage(this, "Warning",commonUtil.getMessageText(this.$i18n,"info_map_icon_hided").replace("{userName}",this.selectedMarker.displayName));
        },
        changeMarkerIcon(iconUrl) {
            let self = this;
            let param = { userId: this.selectedMarker.userId, iconUrl: iconUrl };
            if (iconUrl == "") {
                param.resetIcon = true;
            }
            server.post("/setmarkericon", param)
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let newIcon;
                        if (iconUrl == "") {
                            newIcon = null;
                        } else {
                            newIcon = { url: iconUrl, size: null, origin: null, anchor: null, scaledSize: new google.maps.Size(48,48)};
                        }
                        let userData = self.nameData.get(self.selectedMarker.userId);
                        userData.marker = iconUrl;
                        self.updateLocation();
                        commonUtil.notifyMessage(self, "Success",commonUtil.getMessageText(self.$i18n,"info_map_icon_changed"));
                        break;
                    case constants.STATUS_ERROR_INVALID_PARAMETER:
                        commonUtil.notifyMessage(self, "Warning",commonUtil.getMessageText(self.$i18n,"error_invalid_icon_fileName"));
                        break;
                    default:
                        commonUtil.notifyMessage(self, "Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getLocationData").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch(function(error) {
                commonUtil.putExceptionErrorMessage(self, "changeMarkerIcon", error);
            });
        },
        showMarkerDialog(userData, event) {
            let userAgent = window.navigator.userAgent.toLowerCase();
                // edge and firefox doesn't support TouchEvent
                let eventFired;
                if ((userAgent.indexOf('edge') >= 0) || (userAgent.indexOf('msie') >= 0) || (userAgent.indexOf('trident') >= 0)) {
                    eventFired = (event instanceof MouseEvent);
                } else if (userAgent.indexOf('chrome') >= 0) {
                    eventFired = (event instanceof MouseEvent) || (event[prop] instanceof TouchEvent);
                } else {
                    eventFired = (event instanceof MouseEvent);
                }
                if (eventFired) {
                    let mouseEvt = event;
                    mouseEvt.preventDefault();

                    let markerMenu = document.getElementById("markerMenu");
                    if (this.tabletBrowser) {
                        markerMenu.style.left = mouseEvt.changedTouches[0].clientX + "px";
                        markerMenu.style.top = mouseEvt.changedTouches[0].clientY + "px";
                    } else {
                        markerMenu.style.left = mouseEvt.clientX + "px";
                        markerMenu.style.top = mouseEvt.clientY + "px";
                    }
                    markerMenu.style.display = "block";

                    this.selectedMarker = userData;
                    this.markerContextMenu = true;
                }
        },
        handleChangeMarkerDisplayStatus(newSelectedNode) {
            // close infoWindow of current selected node.
            switch(this.selectedNode.data.type) {
                case constants.OBJECT_USER:
                    let currentUserData = this.nameData.get(this.selectedNode.data.id);
                    if (currentUserData != null) {
                        if (currentUserData.infoWindowOpened) {
                            currentUserData.infoWindow.close();
                            currentUserData.infoWindowOpened = false;
                        }
                    }
                    break;
                case constants.OBJECT_TALKGROUP:
                    for (let currentUserNode of this.selectedNode.childNodes) {
                        let currentUserData = this.nameData.get(currentUserNode.data.id);
                        if (currentUserData != null) {
                            if (currentUserData.infoWindowOpened) {
                                currentUserData.infoWindow.close();
                                currentUserData.infoWindowOpened = false;
                            }
                        }
                    }
                    break;
            }
            // reset hide flag of new selected node.
            switch(newSelectedNode.data.type) {
                case constants.OBJECT_USER:
                    let newUserData = this.nameData.get(newSelectedNode.data.id);
                    if (newUserData != null) {
                        newUserData.hide = false;
                    }
                    break;
                case constants.OBJECT_TALKGROUP:
                    for (let newUserNode of newSelectedNode.childNodes) {
                        let newUserData = this.nameData.get(newUserNode.data.id);
                        if (newUserData != null) {
                            newUserData.hide = false;
                        }
                    }
                    break;
            }
            if (this.selectedNode == newSelectedNode) {
                // redraw the markers when clicked already selected object.
                this.updateLocation();
            }
            this.$refs.scale.handleChangeMarkerDisplayStatus();
        },
        existShowMarker() {
            // there are no shown marker when min-lat = 90 (initial value)
            return (this.minLocInfo.lat != 90)
        }
    },
    created() {
        this.markerIconList = commonUtil.getMarkerIconList();
        let userAgent = window.navigator.userAgent.toLowerCase();
        if ((userAgent.indexOf("android") >= 0) ||
            (userAgent.indexOf("ipad") >= 0)) {
            this.tabletBrowser = true;
        }
    },
    mounted() {
        let self = this;
        this.timerObj = setInterval(function() {
            // should not call initMap until google script has loaded
            if (typeof google != "undefined") {
                let infoBoxScript = document.createElement('script')
                infoBoxScript.setAttribute('src', '../js/infobox_packed.js')
                document.head.appendChild(infoBoxScript)
                self.initMap();
            }
        }, 200)
        this.setScalesRange();
        document.oncontextmenu = new Function("return false")
    },
    watch: {
        'selectedNode': function(selectedNode) {
            this.changeActiveTalker();
        },
        'scales.changeFlg': function(range) {
            if (this.scales.changeFlg) {
                this.changeRange();
            }
        },
        'scales.showTraffic': function(bool) {
            if (this.scales.showTraffic) {
                this.trafficLayer.setMap(this.map);
            } else {
                this.trafficLayer.setMap(null);
            }
        },
        'scales.autoUpdateLocationFlg': function(bool) {
            if (this.scales.autoUpdateLocationFlg) {
                if (this.isUser) {
                    this.changeZoomToAll = false;
                    this.getLocationData(true);
                }
                this.setTimer();
            } else {
                if (this.timer != null) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                if (this.isUser) {
                    this.changeZoomToAll = true;
                    this.scales.disable = false;
                    this.closeInfoWindowOfUser(this.selectedNode.data.id);
                    this.getLocationData(false);
                }
            }
        },
        'scales.updateInterval': function(int) {
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
                this.timer = setInterval(this.updateLocationByTimer, this.scales.updateInterval * 1000);
            }
            this.trackingLastUpdate = this.scales.updateInterval * 2 + 10;
        },
        '$i18n.locale': function(value) {
            location.hash = "#/map"
            location.reload();
        },
        '$route' (to, from) {
            if (to.name == "Map") {
                if (this.scales.autoUpdateLocationFlg) {
                    this.setTimer()
                }
            }
            if (from.name == "Map") {
                clearInterval(this.timer);
                this.timer = null;
            }
        }
    },
    computed: {
        isTalkgroup: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type == constants.OBJECT_TALKGROUP) ;
        },
        isUser: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type == constants.OBJECT_USER) ;
        }
    }
}
</script>
<style>
.ap {
    position: relative;
    height: 100%;
    width: 100%;
}

.map {
    position: relative;
    box-sizing: border-box;
    height: calc(100% - 173px);
    width: 100%;
}
.map-full {
    position: relative;
    box-sizing: border-box;
    height: calc(100% - 115px);
    width: 100%;
}

#scale {
    max-height: 140px;
    width: 100%;
    position: relative;
    top: 0px;
    left: 0px;
    padding-bottom: 10px;
}

.menu {
    width: 170px;
    box-shadow: 3px 3px 5px #888888;
    border-style: solid;
    border-width: 1px;
    border-color: grey;
    border-radius: 2px;
    position: fixed;
    display: none;
}
.menu-record {
    background-color: white;
}
.menu-record:hover {
    background-color: #ecf1fa;
    cursor: pointer;
}
.menu-item {
    font-size: 12px;
    padding: 5px 10px;
    display: block;
}

.marker--not-updated {
	-webkit-filter: grayscale(1); /* Webkit */
	filter: gray; /* IE6-9 */
	filter: grayscale(1); /* W3C */
}

.marker-info {
    position: absolute;
    width: max-content;
    text-align: center;
    top: 50px;
    left: -5px;
    display: none;
    opacity: 0;
    padding: 5px;
    border-radius: 5px;
    color: #000;
    background-color: #fff;
    animation-duration: 0.3s;
    animation-name: show-marker-info;
}

img.marker-img {
    width: 48px;
    height: 48px;
}

.marker-img:hover + .marker-info {
    display: inline-block;
    opacity: 1;
    top: 50px;
}

.marker-info::before {
    content: "";
    position: absolute;
    bottom: 97%;
    left: 20px;
    border: 6px solid transparent;
    border-bottom: 6px solid white;
}

@keyframes show-marker-info {
    0% {
        display: none;
        opacity: 0;
        top: 30px;
    }
    1% {
        display: inline-block;
        opacity: 0;
        top: 30px;
    }
    100% {
        display: inline-block;
        opacity: 1;
        top: 50px;
    }
}

.info-box {
    background-color: #5171cb
}
.info-box-title {
    color:#fff;
    padding: 4px 0px 4px 10px;
    display: block;
    font-size: 14px;
}
.info-box-table {
    background-color: #fff;
    color: #000;
}

button.transparent-copy-button {
    border: 1px solid #5171cb;
    border-radius: 5px;
    color: #5171cb;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    margin: 4px 8px 2px 8px;
    padding: 2px 8px;
    font-size: 8px;
    font-weight: bold;
    white-space:nowrap;
}
button.transparent-copy-button:active {
    background-color: #5171cb;
    opacity: 0.5;
}

</style>
